import React from 'react';
import { FaPlus, FaEdit, FaTrash } from 'react-icons/fa';
import Pagination from '../../components/Pagination';

const ClientesTab = ({
  clientes,
  pesquisaClientes,
  setPesquisaClientes,
  loadingTable,
  filtrarClientes,
  getTelefoneCliente,
  formatCPFCNPJCliente,
  handleEditCliente,
  handleDeleteCliente,
  setShowClienteModal,
  getClientesPaginados,
  pageClientes,
  setPageClientes,
  itemsPerPageClientes,
  setItemsPerPageClientes
}) => {
  const clientesFiltrados = filtrarClientes(clientes);
  const clientesPaginados = getClientesPaginados(clientesFiltrados);

  // Resetar página quando pesquisa mudar
  React.useEffect(() => {
    setPageClientes(1);
  }, [pesquisaClientes, setPageClientes]);
  return (
    <div className="dashboard-section">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
        <h2>Gerenciar Clientes</h2>
        <button className="btn-add" onClick={() => setShowClienteModal(true)}>
          <FaPlus /> Adicionar Cliente
        </button>
      </div>
      
      {/* Campo de pesquisa */}
      <div style={{ marginBottom: '1rem' }}>
        <input
          type="text"
          placeholder="Pesquisar clientes (nome, CPF/CNPJ, telefone, situação...)"
          value={pesquisaClientes}
          onChange={(e) => setPesquisaClientes(e.target.value)}
          style={{
            width: '100%',
            padding: '0.75rem',
            border: '1px solid #ddd',
            borderRadius: '5px',
            fontSize: '0.9rem'
          }}
        />
      </div>
      
      {loadingTable ? (
        <div className="loading">Carregando clientes...</div>
      ) : (
        <div className="imoveis-table">
          <table>
            <thead>
              <tr>
                <th>Nome</th>
                <th>CPF/CNPJ</th>
                <th>Telefone</th>
                <th>Situação</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {clientesFiltrados.length === 0 ? (
                <tr>
                  <td colSpan="5" className="no-data">
                    Nenhum cliente encontrado
                  </td>
                </tr>
              ) : (
                clientesPaginados.map(cliente => (
                  <tr key={cliente.id}>
                    <td>{cliente.nome}</td>
                    <td>{formatCPFCNPJCliente(cliente)}</td>
                    <td>{getTelefoneCliente(cliente)}</td>
                    <td>{cliente.situacao || '-'}</td>
                    <td>
                      <div className="actions">
                        <button
                          onClick={() => handleEditCliente(cliente)}
                          className="btn-action btn-edit"
                          title="Editar"
                        >
                          <FaEdit />
                        </button>
                        <button
                          onClick={() => handleDeleteCliente(cliente.id)}
                          className="btn-action btn-delete"
                          title="Excluir"
                        >
                          <FaTrash />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
          
          {clientesFiltrados.length > 0 && (
            <Pagination
              currentPage={pageClientes}
              totalItems={clientesFiltrados.length}
              itemsPerPage={itemsPerPageClientes}
              onPageChange={setPageClientes}
              onItemsPerPageChange={setItemsPerPageClientes}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default ClientesTab;


